import React from "react";

const benefits = [
  {
    title: "Skilled Development Team",
    text: "You work with a team that handles website, app, and software execution in a structured way. We break work into clear milestones, keep technical decisions transparent, and deliver solutions aligned with your business goals.",
  },
  {
    title: "Clear Project Flow",
    text: "We follow a simple process that keeps you updated at all times. You always know what part of the work is running and what comes next. This helps you stay relaxed while we build your website, software, or app. No confusion and no stress at any point.",
  },
  {
    title: "Fair and Easy Pricing",
    text: "You get good work at a price that fits your budget. We share clear plans so you understand what you are paying for. There are no hidden costs, and each package is made to give you real value. You get strong results without spending extra.",
  },
  {
    title: "Fast Support When You Need It",
    text: "Our team replies quickly when you reach out. You get help without long waits or delays. We guide you with simple steps and solve problems before they grow. You always have someone ready to assist you.",
  },
  {
    title: "SEO-Friendly Work",
    text: "Every site we build comes with clean structure and simple SEO steps. This helps your pages show better on search engines and attracts steady visitors. You get a base that supports long-term online growth.",
  },
  {
    title: "Modern and Clean Designs",
    text: "We build layouts that feel light, simple, and easy for any user. The design fits your brand and keeps your visitors engaged. Whether it is a website or an app, the full experience stays smooth and clear.",
  },
  {
    title: "Secure and Stable Systems",
    text: "Your project comes with safe setup and strong security layers. Our team follows steady methods to keep your data safe. You get a system that runs well every day without sudden issues.",
  },
  {
    title: "Flexible Project Changes",
    text: "We understand that ideas change during the project. You can share updates anytime, and we adjust the work with simple steps. We stay flexible so the final result matches your needs.",
  },
];

const BenefitsSection = () => {
  return (
    <section className="benefits-section">
      <div className="auto-container">
        <div className="section-heading text-center">
          <h3>Benefits of Working With SwiftMazeTech</h3>
          <span className="animate-border"></span>
        </div>

        <div className="row">
          {benefits.map((item) => (
            <div
              className="col-lg-4 col-md-6 col-sm-12"
              key={item.title}
            >
              <div className="benefits-widget">
                <h4>{item.title}</h4>
                <p>{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
export default BenefitsSection;
